// Конфигурируемые данные для лендинга заправки картриджей
export const mockData = {
  contact: {
    phone: "87786293331",
    whatsapp: "77786293331",
    email: "info@darprint.kz",
    workingHours: "Пн-Пт: 9:00-18:00, Сб: 10:00-15:00"
  },
  
  hero: {
    title: "Профессиональная заправка картриджей",
    subtitle: "в Астане",
    description: "Качественная заправка картриджей всех типов. Экономьте до 70% на печати с гарантией качества результата.",
    ctaText: "Заказать заправку",
    image: "https://images.unsplash.com/photo-1706895040634-62055892cbbb"
  },
  
  services: [
    {
      id: 1,
      title: "Лазерные картриджи",
      description: "Заправка черно-белых лазерных картриджей с гарантией качества печати",
      icon: "Printer",
      price: "от 2500 тг",
      image: "https://images.unsplash.com/photo-1715059382493-213b706e95f3"
    },
    {
      id: 2,
      title: "Цветные картриджи",
      description: "Заправка цветных лазерных и струйных картриджей всех популярных брендов",
      icon: "Palette",
      price: "от 3500 тг",
      image: "https://images.unsplash.com/photo-1612815154858-60aa4c59eaa6"
    }
  ],
  
  advantages: [
    {
      id: 1,
      title: "Быстрое выполнение",
      description: "Заправка картриджа за 30 минут. Экспресс-заправка в день обращения",
      icon: "Zap"
    },
    {
      id: 2,
      title: "Гарантия качества",
      description: "Гарантия на заправку 3 месяца. Используем только качественные расходники",
      icon: "Shield"
    },
    {
      id: 3,
      title: "Выгодные цены",
      description: "Экономия до 70% по сравнению с покупкой новых картриджей",
      icon: "DollarSign"
    },
    {
      id: 4,
      title: "Выезд в офис",
      description: "Выезд мастера на дом в офис по Астане",
      icon: "Home"
    }
  ],
  
  cta: {
    title: "Готовы заправить картридж?",
    subtitle: "Свяжитесь с нами прямо сейчас для быстрой консультации и оформления заказа",
    buttonText: "Написать в WhatsApp",
    backgroundImage: "https://images.pexels.com/photos/7578803/pexels-photo-7578803.jpeg"
  }
};
